module.exports = __webpack_public_path__ + "static/media/en-GB.ce605866.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/en-GB.png
// module id = 941
// module chunks = 0